<template>
    <div class="product-item-api-fetched">

        <a class="btn-favorite" v-bind:class="{ active: product.favorite }" @click="addFavorite()"></a>

        <router-link class="box-image" :to="'/producto/' + $root._converToURL(product.nombre, product.id)">

            <div class="out-of-stock" v-if="product.stock < 1">
                Agotado
            </div>

            <!-- <ApiImgPristine :comp="product.gallery[0]" /> -->

            <div class="placed-backg contain img" v-if="!!product.gallery"
                v-bind:style="{ backgroundImage: 'url(' + product.gallery[0] + ')', }">
                <img src="/public/images/shared/product.png" />
            </div>

            <div class="placed-backg contain img" v-else>
                <img src="/public/images/shared/product.png" />
            </div>

        </router-link>

        <div class="product-item-textual-content">

            <div class="box-shot-descr">
                <h6 class="brand">{{ product.sku }}</h6>
                <h6 class="name">{{ product.nombre }}</h6>
            </div>

            <div class="box-shot-descr">
                <div class="box-shipping" v-if="product.envio == 'Gratis'">
                    <div class="shopping">
                        <i class="fas fa-shipping-fast"></i>
                        <span>Envío gratis</span>
                    </div>
                </div>

                <h6 class="price">
                    <span class="cross">{{ product.precio | currency }}</span>
                </h6>
            </div>

            <p class="note">
                <template v-if="product.cantidad == 1">1 Disponible</template>
                <template>{{ product.cantidad }} Disponibles</template>
            </p>

        </div>


        <p class="p-button p-1">
            <router-link class="btn-more" :to="'/producto/' + $root._converToURL(product.nombre, product.id)">
                Ver mas
            </router-link>
        </p>

    </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
export default {
    name: 'productItemApiFetched',
    props: {
        productData: {
            type: Object,
            default: () => ({}),
        },
        // productFetchingAPI: {
        //     type: String,
        //     default: 'catalogo/getitem/',
        // },
        productId: {
            type: [Number, String],
            required: true
        }
    },
    computed: {
        ...mapGetters(['catalogProducts'])
    },
    data: () => {
        return {
            product: {
                favorite: false
            }
        }
    },
    methods: {
        ...mapActions(['favToggleProductID', 'favIsProductID']),
        async addFavorite() {
            await this.favToggleProductID(this.product.productos_id)
            this.reviewIsFav()
        },
        async reviewIsFav() {
            this.product.favorite = await this.favIsProductID(this.product.productos_id)
            this.$forceUpdate()
        },
    },
    beforeMount() {
        this.product = this.productData
    },
    mounted() {
        // this.fetchProductData()
    }
}
</script>

<style lang="less">
.product-item-api-fetched {
    text-align: center;
    color: var(--primary);
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.4);

    display: flex;
    flex-direction: column;
    gap: 10px;
    position: relative;
    justify-content: space-between;

    .btn-favorite {
        position: absolute;
        top: 3px;
        right: 11px;
        text-decoration: none !important;
        z-index: 10;
        display: none;

        &:after {
            content: "\f004";
            font-family: "Font Awesome 5 Pro";
            font-size: 1.8rem;
            font-weight: 400;
            color: var(--primary);
            cursor: pointer;
        }

        &.active {
            &:after {
                font-weight: 700 !important;
            }
        }
    }

    .box-image {
        position: relative;

        .out-of-stock {
            position: absolute;
            padding: 4px 14px 5px 14px;
            bottom: 10px;
            right: 0;
            color: #ffffff;
            font-size: 0.80rem;
            font-weight: 500;
            text-align: center;
            background-color: #f43c3c;
        }

        img {
            width: 100%;
            height: auto;
        }
    }

    .product-item-textual-content {
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 0 10px;

        .name {
            text-transform: uppercase;
        }

        .box-shipping {
            display: block;
            margin-bottom: 12px;

            .shopping {
                display: inline-block;
                padding: 7px 16px;
                color: var(--primary);
                font-size: 0.95rem;
                border-radius: 20px;
                border: 2px solid var(--primary);

                span {
                    margin-left: 2px;
                    font-weight: 500;
                }
            }
        }

        .note {
            text-align: center;
            font-size: 0.8em;
            color: var(--black-dimmed);
        }
    }

    .p-button {
        margin-top: 10px;
        text-align: center;

        .btn-more {
            display: inline-block;
            padding: 8px 30px;
            width: 100%;
            color: #ffffff;
            font-size: 1rem;
            font-weight: 600;
            text-decoration: none !important;
            border-radius: 1px;
            background-color: var(--primary);

            &:hover {
                text-decoration: none !important;
                opacity: 0.8;
                border-color: #797b7b;
            }
        }
    }
}
</style>